export default __webpack_public_path__ + "static/media/filtersicon.6da150fe.svg";